import { baseUseNotifyStore } from '@nuxtDatakodeUtils/store/notify.ts'
import { baseUseConfigStore } from '@nuxtDatakodeUtils/store/config.ts'
import { baseUseUserStore } from '@nuxtDatakodeUtils/store/user.ts'

export const useNotifyStore = baseUseNotifyStore
export const useConfigStore = baseUseConfigStore
export const useUserStore = baseUseUserStore
